import { authedApiFetch } from '../utils/Api';

const inputSignalRulesService = {
	getInputSignalRules: async (
		subscribed = false,
		sortBy = 'created_at',
		sortOrder = 'desc'
	) => {
		const response = await authedApiFetch({
			endpoint: `/input_signal_rules?subscribed=${subscribed}&sort_column=${sortBy}&sort_order=${sortOrder}`,
			method: 'GET',
		});
		return response;
	},

	createInputSignalRule: async (params) => {
		const resp = authedApiFetch({
			endpoint: `/input_signal_rules`,
			method: 'POST',
			payload: params,
		});

		return resp;
	},
};

export default inputSignalRulesService;
